import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span
} from 'components'
import { If, Then } from 'react-if'
import { IConsolidacaoTableEntity } from 'services/NGT/EffectiveConsolidation'
import { COLORS } from 'utils'

import { CollapsibleTable } from '../CollapsibleTable/CollapsibleTable'
import { FormatEffectiveQuantityNumbers as FormatNumber} from '../../utils/FormatEffectiveQuantityNumbers'

interface IReportTable {
  tableData: IConsolidacaoTableEntity
  currentYear: number
  titleHeader: string
  isGeneratePDF: boolean
}

export const ReportTable: React.FC<IReportTable> = ({
  tableData,
  currentYear,
  titleHeader,
  isGeneratePDF
}) => {
  FormatNumber.formatarTableEntity(tableData);
  tableData?.items?.map((item) => item.variacao = item.variacao.toString().replace(/\./g, ",") as unknown as number)
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled backgroundColor={COLORS.blueFonts}>
            <TableRowStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={2}
              >
                {titleHeader}
              </TableCellStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={2}
              >
                {currentYear - 1}
              </TableCellStyled>
              <TableCellStyled
                colSpan={12}
                align="center"
                textColor={COLORS.white}
              >
                {`Quantidade Efetivo - ${currentYear}`}
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
        </TableStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled colSpan={2} />
              <TableCellStyled align="center">Dez</TableCellStyled>
              <TableCellStyled align="center">Jan</TableCellStyled>
              <TableCellStyled align="center">Fev</TableCellStyled>
              <TableCellStyled align="center">Mar</TableCellStyled>
              <TableCellStyled align="center">Abr</TableCellStyled>
              <TableCellStyled align="center">Mai</TableCellStyled>
              <TableCellStyled align="center">Jun</TableCellStyled>
              <TableCellStyled align="center">Jul</TableCellStyled>
              <TableCellStyled align="center">Ago</TableCellStyled>
              <TableCellStyled align="center">Set</TableCellStyled>
              <TableCellStyled align="center">Out</TableCellStyled>
              <TableCellStyled align="center">Nov</TableCellStyled>
              <TableCellStyled align="center">Dez</TableCellStyled>
              <TableCellStyled align="center">Variação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.items.length > 0 &&
              tableData?.items.map((row, index) => (
                <CollapsibleTable
                  key={index}
                  row={row}
                  isGeneratePDF={isGeneratePDF}
                />
              ))}

            <TableRowStyled backgroundColor={COLORS.tableColor}>
              <TableCellStyled colSpan={2}>
                <Span text="TOTAL:" fontWeight="bold" />
              </TableCellStyled>
              <TableCellStyled align="center">
                {tableData?.total?.length >= 12
                  ? FormatNumber.formatarNumero(tableData?.total[12]?.info?.qtdTotalEfetivo)
                  : 0}
              </TableCellStyled>

              {tableData?.total?.map((totalMes, index) => (
                <If condition={index !== 12}>
                  <Then>
                    <TableCellStyled align="center">
                      {FormatNumber.formatarNumero(totalMes.info.qtdTotalEfetivo)}
                    </TableCellStyled>
                  </Then>
                </If>
              ))}
              <TableCellStyled />
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
    </>
  )
}
